export default __webpack_public_path__ + "static/media/msatellite.6bcf15f2.png";